import styles from './CreationSelectionGallery.module.less';
import arrowLeft from '../../assets/images/icons/arrow_left.svg';
import arrowRight from '../../assets/images/icons/arrow_right.svg';
import frame from '../../assets/images/borde.svg';
import coverDisco from '../../assets/images/cover_disco.png';
import CreateSelectionButton from '../UI/CreateSelectionButton';
import React, {useEffect, useReducer, useRef, useState} from 'react';
import coverLibro from "../../assets/images/cover_libro.png";
import coverCarta from "../../assets/images/cover_carta.png";
import coverExLibris from "../../assets/images/cover_ex_libris.png";
import ShowIf from "../UI/ShowIf";

interface GalleryState {
  index: number;
  key: string;
  ref: React.RefObject<HTMLDivElement>;
  current: boolean;
}

const STYLES_SELECTION = 'absolute flex h-full w-full justify-center';

function selectionReducer(state: GalleryState[], action: string): GalleryState[] {
  switch (action) {
    case 'next': {
      const {
        key: prevCurrentKey,
        ref: prevCurrentRef,
        index: prevIndex,
      } = state.find((item) => item.current) as GalleryState;
      if (prevIndex === state.length - 1) {
        return state;
      }

      const oldCurrent = {
        index: prevIndex,
        key: prevCurrentKey,
        ref: prevCurrentRef,
        current: false,
      };
      // @ts-ignore
      prevCurrentRef.current.className = `${STYLES_SELECTION} ${styles['creation-selection-gallery--hidden-selection-left']}`;

      let currentIndex = prevIndex + 1;
      const { key: nextCurrentKey, ref: nextCurrentRef } = state[currentIndex];
      const newCurrent = {
        index: currentIndex,
        key: nextCurrentKey,
        ref: nextCurrentRef,
        current: true,
      };
      // @ts-ignore
      nextCurrentRef.current.className = `${STYLES_SELECTION} ${styles['creation-selection-gallery--visible-selection']}`;

      // Se filtran la selección previa y el actual
      let newState = state.filter((item) => ![prevIndex, currentIndex].includes(item.index));

      return [...newState, oldCurrent, newCurrent].sort((a, b) => a.index - b.index);
    }
    case 'previous': {
      const {
        key: prevCurrentKey,
        ref: prevCurrentRef,
        index: prevIndex,
      } = state.find((item) => item.current) as GalleryState;
      if (prevIndex === 0) {
        return state;
      }

      const oldCurrent = {
        index: prevIndex,
        key: prevCurrentKey,
        ref: prevCurrentRef,
        current: false,
      };
      // @ts-ignore
      prevCurrentRef.current.className = `${STYLES_SELECTION} ${styles['creation-selection-gallery--hidden-selection-right']}`;

      let currentIndex = prevIndex - 1;
      const { key: nextCurrentKey, ref: nextCurrentRef } = state[currentIndex];
      const newCurrent = {
        index: currentIndex,
        key: nextCurrentKey,
        ref: nextCurrentRef,
        current: true,
      };
      // @ts-ignore
      nextCurrentRef.current.className = `${STYLES_SELECTION} ${styles['creation-selection-gallery--visible-selection']}`;

      // Se filtran la selección previa y el actual
      let newState = state.filter((item) => ![prevIndex, currentIndex].includes(item.index));

      return [...newState, oldCurrent, newCurrent].sort((a, b) => a.index - b.index);
    }
    default:
      throw new Error();
  }
}

function CreationSelectionGallery() {
  const discosRef = useRef<HTMLDivElement>(null);
  const librosRef = useRef<HTMLDivElement>(null);
  const cartasRef = useRef<HTMLDivElement>(null);
  const exLibrisRef = useRef<HTMLDivElement>(null);
  const gallery = [
    {
      index: 0,
      key: 'discos',
      ref: discosRef,
      current: true,
    },
    {
      index: 1,
      key: 'libros',
      ref: librosRef,
      current: false,
    },
    {
      index: 2,
      key: 'cartas',
      ref: cartasRef,
      current: false,
    },
    {
      index: 3,
      key: 'exlibris',
      ref: exLibrisRef,
      current: false,
    },
  ];
  const [galleryState, dispatch] = useReducer(selectionReducer, gallery);
  const [isShowNavLeft, setIsShowNavLeft] = useState(false);
  const [isShowNavRight, setIsShowNavRight] = useState(true);

  useEffect(() => {
    setIsShowNavLeft(!galleryState[0].current);
    setIsShowNavRight(!galleryState[galleryState.length - 1].current);
  }, [galleryState])

  const handlePreviousSelection = () => {
    dispatch('previous');
  };

  const handleNextSelection = () => {
    dispatch('next');
  };

  return (
    <div className={`lg:hidden h-full overflow-hidden fixed w-full`}>
      <div className={`w-full flex justify-center h-full items-center overflow-hidden`}>
        <ShowIf condition={isShowNavLeft} >
          <img
              onClick={handlePreviousSelection}
              className={`absolute z-10 ${styles['creation-selection-gallery__arrow--left']}`}
              src={arrowLeft}
              alt=""
          />
        </ShowIf>

        <ShowIf condition={isShowNavRight}>
          <img
              onClick={handleNextSelection}
              className={`absolute z-10 ${styles['creation-selection-gallery__arrow--right']}`}
              src={arrowRight}
              alt=""
          />
        </ShowIf>

        <div ref={discosRef} className={`${STYLES_SELECTION}`}>
          <img
            className={`h-full absolute ${styles['creation-selection-gallery__frame-content']} mt-auto mb-auto top-0 bottom-0`}
            src={frame}
            alt=""
          />
          <div className={` absolute flex justify-center flex-wrap ${styles['creation-selection-gallery__content']} ${styles['creation-selection-gallery__content--mobile']}`}>
            <div className={`flex justify-center flex-wrap w-full`}>
              <div className={`${styles['creation-selection__number']} ${styles['creation-selection__number--mobile']} w-full`}>
                01
              </div>
              <img className={`${styles['creation-selection__cover']} ${styles['creation-selection__cover--mobile']}`} src={coverDisco} alt="" />
              <div className={`${styles['creation-selection__title']} ${styles['creation-selection__title--mobile']} w-full`}>
                Carátula <br /> de disco
              </div>
            </div>
            <div className={`${styles['creation-selection__description']} ${styles['creation-selection__description--mobile']} w-full`}>
              Personaliza tu disco. <br/>
              ¡Pon a sonar tu <br/>
              imaginación!
            </div>
            <CreateSelectionButton className={`${styles['creation-selection__btn--mobile']}`} linkTo="/caratula-disco" />
          </div>
        </div>

        <div
          ref={librosRef}
          className={`${STYLES_SELECTION} ${styles['creation-selection-gallery--hidden-selection-right']}`}
        >
          <img
            className={`h-full absolute ${styles['creation-selection-gallery__frame-content']} mt-auto mb-auto top-0 bottom-0`}
            src={frame}
            alt=""
          />

          <div className={` absolute flex justify-center flex-wrap ${styles['creation-selection-gallery__content']} ${styles['creation-selection-gallery__content--mobile']}`}>
            <div className={`flex justify-center flex-wrap w-full`}>
              <div className={`${styles['creation-selection__number']} ${styles['creation-selection__number--mobile']} w-full`}>
                02
              </div>
              <img className={`${styles['creation-selection__cover']} ${styles['creation-selection__cover--mobile']}`} src={coverLibro} alt="" />
              <div className={`${styles['creation-selection__title']} ${styles['creation-selection__title--mobile']} w-full`}>
                Portada <br /> de libro
              </div>
            </div>
            <div className={`${styles['creation-selection__description']} ${styles['creation-selection__description--mobile']} w-full`}>
              Crea la portada de un <br/>
              libro nuevo con <br/>
              fragmentos de libros <br/>
              viejos. Eso sí, a tu gusto.
            </div>
            <CreateSelectionButton className={`${styles['creation-selection__btn--mobile']}`} linkTo="/portada-libro" />
          </div>
        </div>

        <div
            ref={cartasRef}
            className={`${STYLES_SELECTION} ${styles['creation-selection-gallery--hidden-selection-right']}`}
        >
          <img
              className={`h-full absolute ${styles['creation-selection-gallery__frame-content']} mt-auto mb-auto top-0 bottom-0`}
              src={frame}
              alt=""
          />

          <div className={` absolute flex justify-center flex-wrap ${styles['creation-selection-gallery__content']} ${styles['creation-selection-gallery__content--mobile']}`}>
            <div className={`flex justify-center flex-wrap w-full`}>
              <div className={`${styles['creation-selection__number']} ${styles['creation-selection__number--mobile']} w-full`}>
                03
              </div>
              <img className={`${styles['creation-selection__cover']} ${styles['creation-selection__cover--mobile']}`} src={coverCarta} alt="" />
              <div className={`${styles['creation-selection__title']} ${styles['creation-selection__title--mobile']} w-full`}>
                Carta <br /> &nbsp;
              </div>
            </div>
            <div className={`${styles['creation-selection__description']} ${styles['creation-selection__description--mobile']} w-full`}>
              Escribe una carta <br/>
              que mezcle tus <br/>
              palabras con las de <br/>
              los personajes del <br/>
              archivo.
            </div>
            <CreateSelectionButton className={`${styles['creation-selection__btn--mobile']}`} linkTo="/carta" />
          </div>

        </div>

        <div
            ref={exLibrisRef}
            className={`${STYLES_SELECTION} ${styles['creation-selection-gallery--hidden-selection-right']}`}
        >
          <img
              className={`h-full absolute ${styles['creation-selection-gallery__frame-content']} mt-auto mb-auto top-0 bottom-0`}
              src={frame}
              alt=""
          />
          <div className={` absolute flex justify-center flex-wrap ${styles['creation-selection-gallery__content']} ${styles['creation-selection-gallery__content--mobile']}`}>
            <div className={`flex justify-center flex-wrap w-full`}>
              <div className={`${styles['creation-selection__number']} ${styles['creation-selection__number--mobile']} w-full`}>
                04
              </div>
              <img className={`${styles['creation-selection__cover']} ${styles['creation-selection__cover--mobile']}`} src={coverExLibris} alt="" />
              <div className={`${styles['creation-selection__title']} ${styles['creation-selection__title--mobile']} w-full`}>
                Ex <br /> Libris
              </div>
            </div>
            <div className={`${styles['creation-selection__description']} ${styles['creation-selection__description--mobile']} w-full`}>
              Crea un sello para <br/>
              marcar tus libros. <br/>
              ¡No volveras a perder<br/>
              ninguno!
            </div>
            <CreateSelectionButton className={`${styles['creation-selection__btn--mobile']}`} linkTo="/ex-libris" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreationSelectionGallery;
